export default {"src":"/_next/static/media/flower.b2fa313e.svg","height":74,"width":74,"blurWidth":0,"blurHeight":0};